/*
 * Projection from the shape genericTableStore stores filters in
 * (`{ [key]: [{ value, label }] }`) to the shape the GraphQL filters take.
 *
 * This lives in a helper rather than in the store because there used to be TWO
 * generic-table stores, and the last time this projection was changed in one and
 * not the other, the four tabs on the second one (Home > Matches, Home > Active
 * Submission, Candidates > Matches, Candidates > Per Diem Eligible) sent a shape
 * the backend rejects. The stores are one now; the helper stays as the single
 * place the shape is decided.
 */

/*
 * Filters are stored as a list per key, because most of them are multi-select.
 * `keyword` is not: the schema types it as a String on both MaestroWorkerFilter
 * and MaestroRecruiterJobFilter, and sending the list fails the WHOLE query —
 * "Could not coerce value [\"test\"] to String" — rather than merely ignoring
 * the filter. The table then renders its empty state and the toast is the only
 * clue anything went wrong.
 */
export const SINGLE_VALUE_FILTER_KEYS = ['keyword']

/**
 * @param {object} tableFilters `{ [filterKey]: [{ value, label }] }` for one table
 * @returns {object} `{ [filterKey]: value[] }`, except the single-value keys
 *   above, which come back as the bare first value.
 */
export const projectFilterValues = (tableFilters) =>
	Object.keys(tableFilters || {}).reduce((accumulative, currentKey) => {
		const values = tableFilters[currentKey]?.map((item) => item.value)
		accumulative[currentKey] = SINGLE_VALUE_FILTER_KEYS.includes(currentKey) ? values?.[0] : values
		return accumulative
	}, {})
